import React from 'react';
import { RecommendationBar } from '../../../components/Shared';
import { AdvertisementCiting } from '../../../components/citing/AdvertisementCiting';
import { PubMainTypeEnum } from '../../../types';
import MAGAZINE_PUBINFO_SECTION_FIELDS from '../constants/fieldList/magazine';
import GenericSection from '../../../components/GenericSection';
import { TabHeaders } from '../constants';
import { MoreOptionsSection } from '../../../components/MoreOptions';
var Magazine = function Magazine() {
  var MAGAZINE_SECTION_TITLE_TEST_ID = 'magazine-pub-section-test-id';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(AdvertisementCiting, null), /*#__PURE__*/React.createElement(GenericSection, {
    name: PubMainTypeEnum.PUB_MAGAZINE,
    sectionTitle: "Magazine publication info",
    fieldList: MAGAZINE_PUBINFO_SECTION_FIELDS,
    "data-test": MAGAZINE_SECTION_TITLE_TEST_ID,
    selectedTab: TabHeaders.MAGAZINE
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default Magazine;